import { render, staticRenderFns } from "./StudentObjective.vue?vue&type=template&id=c1d9f1cc&scoped=true&lang=pug&"
import script from "./StudentObjective.vue?vue&type=script&lang=ts&"
export * from "./StudentObjective.vue?vue&type=script&lang=ts&"
import style0 from "./StudentObjective.vue?vue&type=style&index=0&id=c1d9f1cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d9f1cc",
  null
  
)

export default component.exports